import React from 'react'
import { MaterialReactTable } from 'material-react-table'
import { Typography } from '@material-ui/core'

const DashboardTable = ({ eventos, mostrarGestionados }) => {
  const filtrarEventos = () =>
    eventos.filter(
      (evento) =>
        (mostrarGestionados
          ? evento.gestion !== null
          : evento.gestion === null),
    )

  const columns = [
    {
      accessorKey: 'documento_ventas',
      header: 'Número de Pedido',
      enableColumnFilter: true,
    },
    {
      accessorKey: 'proceso',
      header: 'Proceso',
      enableColumnFilter: true,
    },
    {
      accessorKey: 'subproceso',
      header: 'Subproceso',
      enableColumnFilter: true,
    },
    {
      accessorKey: 'material',
      header: 'Material',
      enableColumnFilter: true,
    },
    {
      accessorKey: 'posicion',
      header: 'Posición',
      enableColumnFilter: true,
    },
    {
      accessorKey: 'Fecha_ejecucion',
      header: 'Horas',
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const fechaActual = new Date()
        const fechaEjecucion = new Date(row.original.Fecha_ejecucion)
        const horas = Math.floor(
          (fechaActual - fechaEjecucion) / 3600000,
        )
        return `${Math.abs(horas)} horas`
      },
    },
    {
      accessorKey: 'gestion',
      header: 'Gestión',
      enableColumnFilter: true,
    },
    {
      accessorKey: 'estado',
      header: 'Estado',
      enableColumnFilter: true,
    },
    {
      accessorKey: 'numero_entrega',
      header: 'Numero de Entrega',
      enableColumnFilter: true,
    },
    {
      accessorKey: 'reintentos',
      header: 'Reintento',
      enableColumnFilter: true,
    },
  ]

  return (
    <MaterialReactTable
      columns={columns}
      data={filtrarEventos()}
      enableColumnFilters={true}
      enableColumnActions={false}
      enableSorting={true}
      enableRowActions={false}
      enableRowSelection={false}
      enableDensityToggle={false}
      enableFullScreenToggle={false}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: '#F6F6F6',
          color: '#161615',
          fontSize: '14px',
          fontWeight: 700,
          textAlign: 'center',
        },
      }}
      muiTableBodyRowProps={{
        sx: { '&:nth-of-type(odd)': { backgroundColor: '#f5f5f5' } },
      }}
      initialState={{
        pagination: { pageSize: 20, pageIndex: 0 },
      }}
      muiTablePaginationProps={{
        rowsPerPageOptions: [20, 50, 100],
      }}
      renderTopToolbarCustomActions={() => (
        <Typography variant="h6" sx={{ p: 2 }}>
          Pedidos en Problemas
        </Typography>
      )}
    />
  )
}

export default DashboardTable 